import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';

import { getLoggedUser, getUserPreference } from '../../../User/UserActions';
import { initLanguage, getEnabledLanguages } from '../../../Intl/IntlActions';
import { displayErrors } from '../../../Error/ErrorActions';
import { LANGUAGE_NATIVE_LABELS, getLanguagePreferenceUpdatedMessage } from '../../../../util/websiteLinks';

class FooterLanguageSwitcher extends Component {
    handleSwitchLanguage = lang => {
        if(!lang || lang === this.props.intl.locale) {
            return;
        }

        const previousPreference = this.props.user
            ? getUserPreference(this.props.user, 'language')
            : null;

        this.props.dispatch(initLanguage(lang, this.props.user)).then(result => {
            if(result && this.props.user && result !== previousPreference) {
                displayErrors('success', getLanguagePreferenceUpdatedMessage(result));
            }
        });
    };

    render() {
        const { intl } = this.props;
        const languages = getEnabledLanguages();

        return (
            <div className="footer-languages">
                <span className="footer-languages__label" id="app-footer-lang-label">
                    <FormattedMessage id="language" defaultMessage="Language" />
                </span>
                <nav className="footer-languages__nav" aria-labelledby="app-footer-lang-label">
                    {languages.map(lang => {
                        const isActive = lang === intl.locale;
                        return (
                            <button
                                key={lang}
                                type="button"
                                className={`footer-languages__btn${isActive ? ' is-active' : ''}`}
                                lang={lang}
                                aria-current={isActive ? 'true' : undefined}
                                onClick={() => this.handleSwitchLanguage(lang)}
                            >
                                {LANGUAGE_NATIVE_LABELS[lang] || lang.toUpperCase()}
                            </button>
                        );
                    })}
                </nav>
            </div>
        );
    }
}

FooterLanguageSwitcher.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    user: PropTypes.object,
};

function mapStateToProps(store) {
    return {
        user: getLoggedUser(store),
    };
}

export default connect(mapStateToProps)(injectIntl(FooterLanguageSwitcher));
